import { jsx as d } from "react/jsx-runtime";
import { s as u } from "../../../Popover.module-DJ-RK5B3.js";
import { PopoverCssClass as l } from "../Popover.types.js";
import { usePopover as m } from "../hooks/usePopover.js";
import { useRef as A, useMemo as g, useEffect as b } from "react";
import { focusableElements as v } from "../../../helpers/dom/focusableElements.js";
import { usePopoverActivatorInteractions as T } from "../hooks/usePopoverActivatorInteractions.js";
import { c as x } from "../../../index-2QXL0WYc.js";
const P = [
  "aria-controls",
  "aria-expanded",
  "aria-haspopup",
  "data-active",
  "id",
  "role",
  "tabindex"
], y = (s, c) => {
  const t = s.querySelector("[id]"), a = t == null ? void 0 : t.getAttribute("id");
  t == null || t.removeAttribute("id"), P.forEach((e) => {
    const n = s.getAttribute(e);
    s.removeAttribute(e), n && c.setAttribute(e, n);
  }), a && c.setAttribute("id", a);
}, F = ({
  children: s,
  ...c
}) => {
  const t = m(), a = A(null), e = s == null ? void 0 : s.props, n = T(
    t,
    e
  ), f = g(() => {
    if (t != null && t.show)
      return [
        ...t.getAriaControls(),
        e["aria-controls"],
        t.api.context.floatingId
      ].join(" ").trim();
  }, [e, t]);
  return b(() => {
    var r, o;
    !a.current || !(t != null && t.getVirtualFocus) || t.activeIndex === null || (setTimeout(
      () => {
        var i;
        return (i = t == null ? void 0 : t.api.refs.domReference.current) == null ? void 0 : i.removeAttribute(
          "aria-activedescendant"
        );
      }
    ), a.current.setAttribute(
      "aria-activedescendant",
      ((o = (r = t.list.current) == null ? void 0 : r[t.activeIndex]) == null ? void 0 : o.id) ?? ""
    ));
  }, [t]), /* @__PURE__ */ d(
    "div",
    {
      ...c,
      className: x(u.activator, {
        [l.Active]: t == null ? void 0 : t.show
      }),
      ...t == null ? void 0 : t.interactions.getReferenceProps({
        ...n,
        "aria-controls": f,
        role: e.role,
        ref: (r) => {
          if (!r) return;
          t == null || t.api.refs.setReference(r);
          const o = (r == null ? void 0 : r.querySelector("[role=combobox]")) ?? v(r)[0];
          o && (a.current = o, y(r, o));
        },
        onBlur: (r) => {
          var o;
          (o = r.relatedTarget) != null && o.closest(`.${u.content}`) && (r.preventDefault(), r.stopPropagation());
        },
        onFocus: (r) => {
          var o;
          t != null && t.disabledAutoToggle || r.relatedTarget && (r.relatedTarget.hasAttribute("data-floating-ui-focus-guard") || (o = r.relatedTarget) != null && o.closest(`.${u.content}`)) && t.show && (setTimeout(() => {
            var i;
            (i = a.current) == null || i.focus();
          }), setTimeout(() => {
            t.setShowWithReason(!1, r.nativeEvent, "focus");
          }, 300));
        }
      }),
      children: s
    }
  );
};
export {
  F as PopoverActivator
};
